import React from 'react';
import { formatUnicorn } from "../../../../shared/utils";
//import { useQuery } from '@tanstack/react-query';
import { useCurrentProjectIdContext, useTranslationContext } from "./project-builder-main.jsx";
//import { getProject } from '../../../apis/project-builder';

export default function ProductsListByFamilyPdfView({ index, product, parentId, isAccessory, isMarketingProject }) {

    //const { currentProjectId } = useCurrentProjectIdContext();

    //const { data, isSuccess } = useQuery(['project-detail', currentProjectId], () => getProject(currentProjectId));

    const {translations} = useTranslationContext();
    let discount = "";

    switch (product.discountType) {
        case "FiftyTen":
            discount = (translations.FiftyTenDiscount);
            break;
        case "FiftyTenOpen":
            discount = (formatUnicorn(translations.FiftyTenOpenDiscount, product.discountValue));
            break;
        case "CustomPercentage":
            discount = (formatUnicorn(translations.CustomPercentageDiscount, product.discountValue));
            break;
        case "CustomDollarAmount":
            discount = (formatUnicorn(translations.CustomDollarAmountDiscount, product.discountValue));
            break;
        default:
            discount = ("None");
            break;
    }

    return (
        <>
            <div className="product-card pdf-view-only" key={index}>
                {isAccessory && <div className="product-card-tag">{translations.Accessory} - {parentId}</div>}

                <div className="product-card-media">
                    <img src={product.imageUrl ? product.imageUrl : "https://embed.widencdn.net/img/vollrath/j8hhfhfgqr/x300px@2x/PRO_Photo_Missing_glm_11_22.jpeg?q=80"} alt={product.Title} />
                </div>
                <div className="product-card-content">
                    <div className="product-card-sku">{product.sku}</div>
                    <a href={product.url} className="product-card-title" target="_blank">{product.title}</a>

                    <div className="product-card-attributes">

                        {isMarketingProject
                            ? null
                            : <div className="product-card-price">
                                <span className="product-card-price-label">{translations.ListPrice}</span>
                                <div>
                                    {product.itemDiscount ? (
                                        <>
                                            <span>${product.netPrice.toFixed(2)} </span>
                                            <span className="product-card-price--original">${product.listPrice.toFixed(2)}</span>
                                        </>
                                    ) : (
                                        <span>${product.listPrice.toFixed(2)}</span>
                                    )
                                    }
                                </div>
                                <div className="product-attribute-discount">
                                    <span className="product-attribute-label">{translations.Discount}</span>
                                    <div>{discount}</div>
                                </div>

                            </div>
                        }

                        <div className="product-attribute-net condensed-view-only">
                            <span className="product-attribute-label">{translations.NetTotal}</span>
                            <div>${(product.netPrice * product.quantity).toFixed(2)}</div>
                        </div>
                        <div className="product-attribute-netEach condensed-view-only">
                            <span className="product-attribute-label">{translations.NetEach}</span>
                            <div>${product.netPrice.toFixed(2)}</div>
                        </div>
                        <div className="product-attribute-discount condensed-view-only">
                            <span className="product-attribute-label">{translations.Discount}</span>
                            <div>{discount}</div>
                        </div>
                        <div className="product-attribute-discount condensed-view-only">
                            <span className="product-attribute-label">{translations.ListEach}</span>
                            <div>${product.listPrice.toFixed(2)}</div>
                        </div>

                        <div className="ml-auto rounded-border quantity">{translations.Qty}: ({product.quantity})</div>
                    </div>
                </div>
            </div>

        </>

    );
}